"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLocationByIpService = void 0;
const utils_1 = require("@hc-frontend/utils");
const __1 = require("..");
/**
 * Fetch the location using the current ip of the browser
 *
 * @public
 *
 * @returns The location information based on the current ip of the request or null if we can't determine the location
 *
 * @example
 * ```ts
 * const location = await fetchLocationByIpService();
 * ```
 */
async function fetchLocationByIpService() {
    const { parsedBody } = await (0, utils_1.fetchJSON)((0, __1.geoIpURI)());
    return (parsedBody === null || parsedBody === void 0 ? void 0 : parsedBody.ip) ? parsedBody : null;
}
exports.fetchLocationByIpService = fetchLocationByIpService;
//# sourceMappingURL=fetch-location-by-ip-service.js.map